import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterItem, PropertyFilter } from '../../store/search/types';

@Pipe({
  name: 'isOneItemInPropertyActive',
  standalone: false,
})
export class IsOneItemInPropertyActivePipe implements PipeTransform {
  transform(activeFilters: Filter[], propertyFilter: PropertyFilter): boolean {
    let isActive: boolean = false;
    let predicate = activeFilters.find(
      (filter) =>
        filter.tag === 'Property' &&
        propertyFilter.items.some(
          (item) =>
            propertyFilter.propertyId + '/' + item.label === filter.name,
        ),
    );
    isActive = predicate != undefined;
    return isActive;
  }
}
